<template>
    <vx-card>
        <div class="vx-row">
            <h3>Formulaire de contact</h3>
        </div>
        <div class="vx-row mt-2">
            <div class="vx-col" style="width: 300px;">
                <vs-select
                    autocomplete
                    v-model="selectedContract"
                    class="w-full select-medium mr-2 pt-6"
                    placeholder="N° de contrat"
                >
                <vs-select-item
                    :key="index"
                    :value="item.contract_id"
                    :text="'Contrat N°' + item.contract_id + ' (' + item.name + ')'"
                    v-for="(item, index) in userContracts"
                    class="w-full"
                />
            </vs-select>
            </div>
            <div class="vx-col" style="width: 500px;"><vs-input class="w-full" label="Sujet" v-model="subject" /></div>
        </div>
        <div class="vx-row mt-2">
            <div class="vx-col">
                <vs-textarea
                    label="Message"
                    v-model="message"
                    height="200px"
                    width="800px"
                />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col" style="width: 825px;">
                <vs-button class="shadow-lg float-right"
                    icon-pack="material-icons" icon="send"
                    color="primary"
                    @click="sendMessage()"
                >Envoyer</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
// import store from "@/store/store";

import VueCookies from "vue-cookies";
export default {
	name: "ContactForm",
	props: {
		contractsUsersInfo: {
			type: Object,
			default: null
		}
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	data(){
		return {
			apiUrl: this.$store.state.backendApiUrl,
			selectedContract: null,
			userContracts: [],
			subject: "",
			message: ""
		};
	},
	created() {
		this.getUserContracts(this.$route.params.userId ? this.$route.params.userId : this.activeUser.id);
	},
	methods: {
		getUserContracts(userId){
			return new Promise((resolve, reject) => {
				this.$http.get(this.apiUrl + "contract/getcu/" + userId)
					.then(result => {
						// for(let i = 0; i < result.length; i++){

						// }
						this.userContracts = result.data;
						resolve(result.data);
					})
					.catch(err => {
						reject(err);
					});
			});
		},
		sendMessage(){
			return new Promise((resolve, reject) => {
				if(this.selectedContract != null && this.subject != "" && this.message != ""){
					let collaboratorsEmail = [];

					let foundContract = null;
					this.$http.post(this.apiUrl + "mail/sendclientform", {
						user_id: this.$route.params.userId ? this.$route.params.userId : this.activeUser.id,
						// collaborators_mails: collaboratorsEmail,
						contract_id: this.selectedContract,
						subject: this.subject,
						message: this.message
					})
						.then(result => {
							this.$vs.notify({
								title: "Succès",
								text: "Message envoyé."
							});
							this.$router.go(-1);
							resolve(true);
						});
				}
				else{
					this.$vs.notify({
						title: "Erreur",
						text: "Veuillez remplir tous les champs."
					});
				}
			});
		}
	},
};
</script>
